import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const AboutSection = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ["start end", "center center"]
  });

  // Create scrolling animations - modified to use scale for title instead of width
  const titleScale = useTransform(scrollYProgress, [0, 0.3], [0, 1]);
  const titleOpacity = useTransform(scrollYProgress, [0, 0.3], [0, 1]);
  const imageX = useTransform(scrollYProgress, [0.1, 0.5], [-100, 0]);
  const imageOpacity = useTransform(scrollYProgress, [0.1, 0.5], [0, 1]);

  // Reveal animation variants for text elements
  const revealVariants = {
    hidden: {
      opacity: 0,
      x: -50
    },
    visible: {
      opacity: 1,
      x: 0
    }
  };
  return <motion.section ref={sectionRef} className="relative overflow-hidden pt-16 pb-20 md:pt-24 md:pb-28 bg-white">
      {/* Centered Title Container */}
      <div className="text-center mb-16">
        <motion.h2 ref={sectionRef} style={{
        scale: titleScale
      }} className="font-playfair mb-6 text-4xl md:text-7xl my-0 py-[37px] md:py-[44px]">
          <span className="text-[#1a1f2c]">ABOUT </span>
          <span className="text-heaven-gold">SELAH</span>
        </motion.h2>
      </div>

      <div className="container mx-auto px-4 md:px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Column - Image with slide-in animation */}
          <motion.div style={{
          x: imageX,
          opacity: imageOpacity
        }} transition={{
          duration: 0.8,
          ease: "easeOut"
        }} className="relative">
            <div className="relative overflow-hidden rounded-2xl">
              <motion.img src="https://bbhhusjprzalcwvkgvsa.supabase.co/storage/v1/object/public/photos//mask%20image.png" alt="Woman using phone" className="w-full h-auto object-cover rounded-2xl" style={{
              filter: "brightness(1.05) contrast(0.95)",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)"
            }} />
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,rgba(255,255,255,0.5)_50%,rgba(255,255,255,0.8)_100%)] rounded-2xl" />
            </div>
          </motion.div>

          {/* Right Column - Content with Reveal Animation */}
          <div className="space-y-8 overflow-hidden">
            {/* Title with reveal animation */}
            <div className="overflow-hidden">
              <motion.h2 variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
              once: false,
              margin: "-100px 0px"
            }} transition={{
              duration: 0.6,
              ease: "easeOut"
            }} className="text-4xl md:text-5xl font-playfair text-[#1A1F2C] leading-tight">
                Jesus told His disciples "If you don't have a sword—sell your cloak and buy one." (Luke 22:36)
              </motion.h2>
            </div>

            {/* Subtitle with reveal animation */}
            <div className="overflow-hidden">
              <motion.p variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
              once: false,
              margin: "-100px 0px"
            }} transition={{
              duration: 0.6,
              delay: 0.1,
              ease: "easeOut"
            }} className="text-lg text-blue-600 leading-relaxed font-playfair font-medium md:text-2xl">
                That command was urgent. Strategic. Prepared. And today, the world has changed—but the call hasn't.
              </motion.p>
            </div>

            <div className="space-y-6">
              {/* First paragraph with reveal animation */}
              <div className="overflow-hidden">
                <motion.p variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
                once: false,
                margin: "-100px 0px"
              }} transition={{
                duration: 0.6,
                delay: 0.2,
                ease: "easeOut"
              }} className="text-base md:text-lg text-gray-700 leading-relaxed font-playfair">
                  AI is the sword of this generation. It's fast. It's evolving. It's already shaping how people think, feel, and believe.
                </motion.p>
              </div>

              {/* Second paragraph with reveal animation */}
              <div className="overflow-hidden">
                <motion.p variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
                once: false,
                margin: "-100px 0px"
              }} transition={{
                duration: 0.6,
                delay: 0.3,
                ease: "easeOut"
              }} className="text-base md:text-lg text-gray-700 leading-relaxed font-playfair">
                  Selah is AI surrendered to Jesus. We didn't just plug in a chatbot and call it Christian. Our AI has been shaped by sound theology, built with biblical conviction, and refined to keep Christ at the center.
                </motion.p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.section>;
};
